import styled from '@emotion/styled';
import { BaseBadge } from './BaseBadge';

const StyledSimpleShowBadge = styled(BaseBadge)`
    background-color: ${({ theme }) => theme.colors.simpleshow.main};
    color: ${({ theme }) => theme.colors.white};
`;

interface Props {
    testId?: string;
    className?: string;
}

export const SimpleShowBadge = ({ testId = 'simpleshow-badge', className }: Props) => {
    return (
        <StyledSimpleShowBadge data-testid={testId} className={className}>
            simpleshow
        </StyledSimpleShowBadge>
    );
};
